import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'roleTranslate',
  standalone: true,
  pure: false,
})
export class RoleTranslatePipe implements PipeTransform, OnDestroy {
  constructor(private readonly translate: TranslateService) {}

  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    return this.translate.instant(`role.${value}`) || value;
  }

  ngOnDestroy(): void {
    // no cleanup required currently
  }
}
